import { useEffect } from 'react';

export const STORAGE_EVENT_DATE = 'storage:menu-refresh';

export function useStorageEvent(eventName: string, handler: () => void): void {
    useEffect(() => {
        window.addEventListener(eventName, handler);
        return () => window.removeEventListener(eventName, handler);
    }, [eventName, handler]);
}
